module.exports = __webpack_public_path__ + "static/media/84.8aa3c377.png";